export const toaststyle = {
  position: "bottom-left",
  autoClose: 1000,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: false,
  draggable: false,
  progress: undefined,
  theme: "light",
};
